// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  art: "IntroArt__art",
  cell: "IntroArt__cell",
  drawn: "IntroArt__drawn",
  settled: "IntroArt__settled",
  sline: "IntroArt__sline",
};
